import { usePathParam } from 'utils/use-get-keys-from-url';

export default function useAndroidDeepLinkQueryParam() {
  const isAndroid = usePathParam('isAndroid') === 'isAndroid';

  return isAndroid ? `?justAndroidDeepLink=1` : '';
}
